module.exports = __webpack_public_path__ + "img/company_logo.89d3d196.png";